import { FaCheckCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { capitalizeFirstLetters } from "../../../utils/stringUtils";
import { PiCaretLeftBold } from "react-icons/pi";

const ProfileSubscriptionPlan = () => {
  const navigate = useNavigate();

  const subscriptionPlan = "free";

  const planDetails: PlanDetails = {
    free: {
      title: "free plan",
      description: "Upgrade to the pro package to unlock more features.",
      buttonText: "Upgrade",
      features: [
        "Basic report submission",
        "Incident follow-up & case tracking",
        "Email notifications",
        "Limited storage for evidence",
        "Access to educational resources",
        "Community support forum (read-only)",
      ],
    },
    pro: {
      title: "pro plan",
      description: "Enjoy all the features or downgrade anytime.",
      buttonText: "Downgrade",
      features: [
        "Anonymous secure chat with advocates",
        "Advanced privacy controls",
        "Priority processing & dedicated support",
        "Detailed reporting analytics",
        "Emergency SOS features",
        "AI-based risk assessment & recommendations",
        // "Multi-channel reporting (email, WhatsApp, voice)",
        "Secure document vault",
        "Exclusive community support forums",
        "Incident review with legal experts",
        // "Voice-activated reporting",
        "Multi-language support with professional translations",
      ],
    },
  };

  const plan = planDetails[subscriptionPlan];

  const handleActivate = () => {
    navigate("/profile/subscription/change");
  };

  return (
    <div className="flex flex-col h-full">
      <Link
        to="/profile"
        className="text-gray-7 text-lg mb-4 flex items-center gap-2"
      >
        <PiCaretLeftBold /> Back to profile
      </Link>
      <div className="flex flex-col bg-gray-2 py-4 px-6 rounded-[13px] mb-9">
        <h2 className="text-gray-7 font-semibold text-4xl mb-3">
          You are currently on the {plan.title}
        </h2>
        <p className="mb-6 font-mediumm text-xl">{plan.description}</p>
        <button
          className="bg-black rounded-[10px] py-3 px-[43.5px] text-white self-start"
          onClick={handleActivate}
        >
          {plan.buttonText}
        </button>
      </div>

      <div className="flex justify-center items-end gap-y-8 gap-x-16 flex-wrap h-full overflow-scroll">
        {Object.keys(planDetails).map((planName, i) => (
          <div
            key={i}
            className="flex flex-col justify-between rounded-[32px] bg-gray-7 p-6 text-white w-[350px] min-h-[624px] gap-8"
          >
            <div>
              <h4 className="font-bold text-2xl">
                {capitalizeFirstLetters(planName)}
              </h4>
              <h6 className="font-bold text-4xl pb-6">$0/yr</h6>
              <ul className="flex flex-col gap-4">
                {planDetails[planName].features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <FaCheckCircle className="mt-1" /> {feature}
                  </li>
                ))}
              </ul>
            </div>

            <button
              onClick={handleActivate}
              className="text-white font-bold text-2xl"
            >
              Activate
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileSubscriptionPlan;

type PlanDetails = {
  [key: string]: {
    title: string;
    description: string;
    buttonText: string;
    features: string[];
  };
};
